<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Files
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <b-col
            v-if="isMobile()"
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-space_between mb-1 mb-md-0"
          >
            <div class="bulk_selection d-flex">
              <div class="action-left pt-50">
                <b-form-checkbox
                  :checked="selectAllFilesCheckbox"
                  :indeterminate="isSelectAllFilesCheckboxIndeterminate"
                  @change="selectAllCheckboxUpdate"
                >
                  Select All
                </b-form-checkbox>
              </div>
              <b-dropdown
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="mx-1 dropdown__left-align-adjust-mobile"
                right
                text="Bulk Actions"
                variant="primary"
                :disabled="!selectedFiles.length"
              >
                <b-dropdown-item v-if="canViewThisAction('send-email-statement', 'File')">
                  Email Statement of Account to Customer
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <span class="text-muted">Showing <br>{{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>
          <b-col
            v-else
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <div class="action-left pt-50">
              <b-form-checkbox
                :checked="selectAllFilesCheckbox"
                :indeterminate="isSelectAllFilesCheckboxIndeterminate"
                @change="selectAllCheckboxUpdate"
              >
                Select All
              </b-form-checkbox>
            </div>
            <b-dropdown
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mx-1 dropdown__left-align-adjust"
              right
              text="Bulk Actions"
              variant="primary"
              :disabled="!selectedFiles.length"
            >
              <!-- <b-dropdown-item @click="downloadBulkCSV">
                Download CSV
              </b-dropdown-item> -->
              <b-dropdown-item @click="bulkStatementEmail">
                Email Statement of Account to Customer
              </b-dropdown-item>
            </b-dropdown>
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="8"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Customer Name"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = '';"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="nric"
                  placeholder="NRIC"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="nric = '';"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="fileNo"
                  placeholder="File No."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="fileNo = '';"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="lotNo"
                  placeholder="Zone/Lot No."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="lotNo = '';"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-form-all-files"
                ref="filter_dropdown_all_files"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <file-filters
                  :file-status-filter.sync="fileStatusFilter"
                  :payment-status-filter.sync="paymentStatusFilter"
                  :product-filter.sync="productFilter"
                  :customer-type-filter.sync="customerTypeFilter"
                  :booking-date-filter.sync="bookingDateFilter"
                  :confirm-date-filter.sync="confirmDateFilter"
                  :file-status-options="fileStatusOptions"
                  :payment-status-options="paymentStatusOptions"
                  :product-options="productOptions"
                  :customer-options="customerOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="bookingDateFilter || confirmDateFilter || fileStatusFilter.length || paymentStatusFilter.length || productFilter.length || customerTypeFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="fileStatusVal in fileStatusFilter"
                  :key="fileStatusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromFileStatusFilter(fileStatusVal)"
                  >
                    <span class="text-capitalize">{{ fileStatusVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="statusVal in paymentStatusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromPaymentStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="productVal in productFilter"
                  :key="productVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeProductFilter(productVal)"
                  >
                    <span class="text-capitalize">{{ productVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="customerVal in customerTypeFilter"
                  :key="customerVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeCustomerTypeFilter(customerVal)"
                  >
                    <span class="text-capitalize">{{ customerVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-if="bookingDateFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="bookingDateFilter = ''"
                  >
                    {{ bookingDateFilter }}
                  </b-form-tag>
                </li>
                <li
                  v-if="confirmDateFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="confirmDateFilter = ''"
                  >
                    {{ confirmDateFilter }}
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refFilesTable"
        class="position-relative event_list min-height-200"
        :items="filesData"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(fileID)="data">
          <div class="text-nowrap">
            <b-form-checkbox
              :checked="selectedFiles.includes(data.item.fileID)"
              @change="toggleSelectedFiles(data.item.fileID)"
              @click.native.stop
            >
              <b-button
                v-if="canViewThisAction('show', 'File')"
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="link"
                class="weight-600 align-middle detail-view-id"
                :to="{ name: 'customers-files-show', params: { id: data.item.fileID } }"
              >
                {{ data.item.fileNo }}
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="link"
                class="text-bold align-middle detail-view-id not-button"
              >
                {{ data.item.fileNo }}
              </b-button>
            </b-form-checkbox>
          </div>
        </template>

        <template #cell(nvsFileType)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.nvsFileType }}</span>
            <br>
            <span
              v-if="data.item.lotLocation"
              class=""
            >
              {{ data.item.lotLocation }}
            </span>
            <span
              v-else-if="data.item.packageName"
              class=""
            >
              {{ data.item.packageName }}
            </span>
          </div>
        </template>

        <template #cell(purchasers)="data">
          <div
            v-for="(purchaser, key) in data.item.purchasers"
            :key="key"
            class=""
          >
            <b-button
              v-if="canViewThisAction('show', 'Customer') && purchaser.customer"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id text-uppercase"
              :to="{ name: 'customers-customers-show', params: { id: purchaser.customer } }"
            >
              {{ purchaser.name }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle not-button text-uppercase"
            >
              {{ purchaser.name }}
            </b-button>
            <br>
            <span
              v-if="purchaser.encryptedNric"
              class=""
            >
              {{ purchaser.encryptedNric }}
            </span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(nvsFileStatus)="data">
          <b-badge
            :variant="`light-${resolveFileStatusVariant(data.item.nvsFileStatus)}`"
            class="text-capitalize"
          >
            {{ data.item.nvsFileStatus ? data.item.nvsFileStatus.toLowerCase() : '-' }}
          </b-badge>
        </template>

        <!-- Column: Status -->
        <template #cell(paymentStatus)="data">
          <b-badge
            :variant="`light-${resolvePaymentStatusVariant(data.item.paymentStatus)}`"
            class="text-capitalize"
          >
            {{ data.item.nvsFileStatus && data.item.nvsFileStatus.toLowerCase() === 'book' ? 'Booking Fee' : data.item.paymentStatus || '-' }}
          </b-badge>
        </template>

        <template #cell(bookingDate)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.bookingDate ? dateFormat(data.item.bookingDate) : '-' }}</span>
          </div>
        </template>

        <template #cell(confirmDate)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.confirmDate ? dateFormat(data.item.confirmDate) : '-' }}</span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ getCreatedBy(data.item) }}</span>
            <br>
            <span class="">{{ getCreatedAt(data.item) }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'File') || canViewThisAction('send-email-statement', 'File') || canViewThisAction('download-soa', 'File')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'File')"
              :to="{ name: 'customers-files-show', params: { id: data.item.fileID } }"
            >
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('download-soa', 'File')"
              @click="downloadSoa(data.item)"
            >
              <span class="align-middle ml-50">Download Statement of Account</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('send-email-statement', 'File')"
              @click="openEmailStatementModal(data.item)"
            >
              <span class="align-middle ml-50">Email Statement of Account to Customer</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

        <template #bottom-row="">
          <td
            class=""
            colspan="9"
          >
            <b-row>
              <b-col
                md="6"
                sm="6"
                class="my-25"
              >
                <b-form-group
                  class="mb-0"
                >
                  <label class="d-inline-block text-sm-left mr-50 weight-400 fs-14">Per page</label>
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                    class="w-50"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                sm="6"
                class="ml-auto my-25 text-right"
              >
                <div v-if="totalFiles == selectedFiles.length">
                  <span>All {{ totalFiles }} items are selected.</span>
                  <b-button
                    variant="link"
                    class="px-0"
                    @click="clearSelection"
                  >
                    Clear Selection
                  </b-button>
                </div>
                <div v-else-if="computationSelection && totalFiles > selectedFiles.length">
                  <span v-if="computationSelection == filesData.length">All {{ computationSelection }} items on this page are selected.</span>
                  <span v-else>{{ computationSelection }} items on this page are selected.</span>
                  <b-button
                    variant="link"
                    class="px-0"
                    @click="selectAllItems"
                  >
                    Select all {{ totalFiles }} items
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </td>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalFiles > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-show="totalFiles > filesData.length"
            v-model="currentPage"
            :total-rows="totalFiles"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

    <b-modal
      id="email-statement-modal"
      ref="email-statement-modal"
      modal-class="status-update-modal sign-modal-adjust sign-form_modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Email Statement of Account to Customer"
      @ok="sendEmailStatement"
      @cancel="closeStatementModal"
    >
      <div class="">
        <b-form-group
          label="Customer Name"
          label-for="customer-name"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Customer Name"
            vid="customer-name"
            rules=""
          >
            <b-form-input
              id="customer-name"
              v-model="customerNameVal"
              placeholder="Lin Chai"
              class="mb-0"
              readonly
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Email Address"
          label-for="customer-email"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Email Address"
            vid="customer-email"
            rules="required"
          >
            <b-form-input
              id="customer-email"
              v-model="customerEmailVal"
              placeholder="email@domain.com"
              class="mb-0"
              :readonly="hasEmailAddress ? true : false"
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Message"
          label-for="statement-message"
          class="mb-20"
        >
          <validation-provider
            #default="{ errors }"
            name="Message"
            vid="statement-message"
            rules="required"
          >
            <b-form-textarea
              id="statement-message"
              v-model="statementMessage"
              placeholder="Statement of Account"
              class="mb-0"
              rows="9"
              :state="(errors.length > 0) ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="success"
          class="custom-icon"
          :disabled="!customerEmailVal"
          @click="ok()"
        >
          <feather-icon
            icon="SendIcon"
            size="16"
            class="mr-50"
          />
          <span class="align-middle">Send</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormInput, BTable, BFormCheckbox, BInputGroup, BInputGroupAppend, BFormTextarea,
  BBadge, BDropdown, BDropdownItem, BPagination, BButton, BFormTag, BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import store from '@/store'
import ToastificationContentCustom from '../../operation/ToastificationContentCustom.vue'

import useFileList from './useFileList'
import fileListStoreModule from './fileListStoreModule'
import FileFilters from './FileFilters.vue'

export default {
  components: {
    // UserListAddNew,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,
    BFormGroup,
    BFormSelect,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,

    FileFilters,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      bulkStatus: 'completed',
      bulkStatusValidation: false,
      bulkStatusError: 'Valid status is required',
      paymentStatusOptions: [
        { key: 'Booking Fee', value: 'Booking Fee' },
        { key: 'Downpayment', value: 'Downpayment' },
        { key: 'Ongoing Installment', value: 'Ongoing Installment' },
        { key: 'Pending Payment', value: 'Pending Payment' },
        { key: 'Fully Paid', value: 'Fully Paid' },
        { key: 'Reactivation Fee', value: 'Reactivation Fee' },
      ],
      productOptions: [
        { key: 'Little Buddha', value: 'Little Buddha' },
        { key: 'Funeral Service Package', value: 'Funeral Service Package' },
        { key: 'Niche', value: 'Niche' },
        { key: 'Pedestal', value: 'Pedestal' },
        { key: 'Urn', value: 'Urn' },
      ],
      customerOptions: [
        { label: 'Nirvana SG Users', value: 'Nirvana SG Users' },
        { label: 'Non Nirvana SG Users', value: 'Non Nirvana SG Users' },
      ],
      fileStatusOptions: [
        { key: 'Open', value: 'Open' },
        { key: 'Book', value: 'Book' },
        { key: 'Confirm', value: 'Confirm' },
        { key: 'Confirm/Exercise', value: 'Confirm/Exercise' },
        { key: 'Confirm/Redeem', value: 'Confirm/Redeem' },
      ],
      toSend: '',
      showFilterDropdown: process.env.VUE_APP_SHOW_FILTER_DROPDOWN,
      customerNameVal: '',
      customerEmailVal: '',
      customerContactVal: '',
      statementMessage: '',
      fileType: '',
      fileNumber: '',
      fileID: '',
      pageOptions: [10, 20, 30, 40, 50],
      required,
      hasEmailAddress: '',
    }
  },

  methods: {
    getCreatedBy(item) {
      if (item.createdByNvs) {
        return item.createdByNvs.name
      }
      if (item.createdBy) {
        return item.createdBy
      }

      return ''
    },
    getCreatedAt(item) {
      if (item.createdAtNvs) {
        return this.dateFormatWithTime(item.createdAtNvs)
      }
      if (item.createdAt) {
        return this.dateFormatWithFormatNTZ(item.createdAt, 'DD/MM/YYYY, hh:mma ')
      }

      return ''
    },
    selectAllItems() {
      this.$http.get('customer/files/select/all/statement',
        {
          params: {
            search: this.searchQuery,
            fileNo: this.fileNo,
            nric: this.nric,
            lotNo: this.lotNo,
            fileStatus: this.fileStatusFilter,
            paymentStatus: this.paymentStatusFilter,
            product: this.productFilter,
            customerType: this.customerTypeFilter,
            bookingDate: this.bookingDateFilter,
            confirmDate: this.confirmDateFilter,
          },
        })
        .then(response => {
          if (response.data.success) {
            this.selectedFiles = response.data.files
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    hideFilter() {
      this.$refs.filter_dropdown_all_files.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_all_files.show(true)
    },
    removeProductFilter(item) {
      const index = this.productFilter.indexOf(item)
      if (index > -1) {
        this.productFilter.splice(index, 1)
      }
    },
    removeCustomerTypeFilter(item) {
      const index = this.customerTypeFilter.indexOf(item)
      if (index > -1) {
        this.customerTypeFilter.splice(index, 1)
      }
    },
    removeFromPaymentStatusFilter(item) {
      const index = this.paymentStatusFilter.indexOf(item)
      if (index > -1) {
        this.paymentStatusFilter.splice(index, 1)
      }
    },

    removeFromFileStatusFilter(item) {
      const index = this.fileStatusFilter.indexOf(item)
      if (index > -1) {
        this.fileStatusFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.bookingDateFilter = ''
      this.confirmDateFilter = ''
      this.productFilter = []
      this.paymentStatusFilter = []
      this.fileStatusFilter = []
      this.customerTypeFilter = []
    },
    resolveFileStatusVariant(status) {
      if (status === 'OPEN') return 'warning'
      if (status === 'BOOK') return 'info'
      return 'success'
    },
    resolvePaymentStatusVariant(status) {
      if (status === 'Fully Paid') return 'success'
      if (status === 'Ongoing Installment') return 'info'
      if (status === 'Pending Payment') return 'warning'
      if (status === 'Reactivation Fee') return 'danger'
      return 'secondary'
    },
    openEmailStatementModal(item) {
      if (item.purchasers && item.purchasers.length) {
        const firstPurchaser = item.purchasers[0]
        this.hasEmailAddress = firstPurchaser.email ? firstPurchaser.email : ''
        this.customerNameVal = firstPurchaser.name ? firstPurchaser.name : ''
        this.customerEmailVal = firstPurchaser.email ? firstPurchaser.email : ''
        this.customerContactVal = firstPurchaser.contact ? firstPurchaser.contact : ''
        this.fileType = item.nvsFileType ? item.nvsFileType : ''
        this.fileNumber = item.fileNo ? item.fileNo : ''
        this.fileID = item.fileID ? item.fileID : ''
        this.statementMessage = `Here is the Statement of Account for your purchase with us for ${item.nvsFileType} (file no.: ${item.fileNo}), as at ${moment().format('DD MMM YYYY')}. The statement provides a detailed summary of your transactions and current account balance.

Please be informed that the PDF is password-protected using your mobile number (e.g. 912345678).`
        this.$root.$emit('bv::show::modal', 'email-statement-modal', '')
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Purchaser Data is missing',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    closeStatementModal() {
      this.$root.$emit('bv::hide::modal', 'email-statement-modal', '')
    },
    bulkStatementEmail() {
      this.$swal({
        title: `Email Statement of<br>Account to ${this.selectedFiles.length} Customers?`,
        html: 'Are you sure you want to email Statement<br>of Account to selected customers?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, send',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            formData.append('selectedFiles', JSON.stringify(this.selectedFiles))
            formData.append('url', `${window.location.origin}`)
            this.$http.post('customer/files/send/soa/statement/bulk', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.$swal({
                  title: 'Sending of SOA is queued',
                  html: '<strong>An SOA Send report will be sent to your<br>email</strong>, detailing sending status for each file.',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/fly.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  confirmButtonText: 'Okay, got it',
                  cancelButtonText: 'Cancel',
                  customClass: {
                    confirmButton: 'btn btn-primary ml-1',
                    cancelButton: 'btn btn-outline-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    sendEmailStatement() {
      let contact = this.customerEmailVal
      if (this.customerContactVal) {
        contact = this.customerContactVal.slice(-8)
      }
      const formData = new FormData()
      formData.append('customerName', this.customerNameVal)
      formData.append('customerEmail', this.customerEmailVal)
      formData.append('message', this.statementMessage)
      formData.append('fileType', this.fileType)
      formData.append('fileNo', this.fileNumber)
      formData.append('contact', contact)
      formData.append('fileID', this.fileID)
      formData.append('url', `${window.location.origin}`)

      this.$http.post('customer/files/send/soa/statement', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Statement of Account Email Sent',
                text: response.data.message,
                icon: 'CheckCircleIcon',
                variant: 'success',
                hideClose: true,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    downloadSoa(item) {
      const formData = new FormData()
      formData.append('fileID', item.fileID)

      this.$http.post('customer/files/soa/download', formData, {
        headers: { 'Content-Type': 'multipart/form-data', Accept: 'application/pdf' },
        responseType: 'arraybuffer',
      })
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `SOA-${item.fileNo.replace(/[/ ]/gi, '-')}.pdf`
          link.click()

          link.remove()
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data?.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const FILE_APP_STORE_MODULE_NAME = 'app-all-files'

    // Register module
    if (!store.hasModule(FILE_APP_STORE_MODULE_NAME)) store.registerModule(FILE_APP_STORE_MODULE_NAME, fileListStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(FILE_APP_STORE_MODULE_NAME)) store.unregisterModule(FILE_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchFiles,
      tableColumns,
      perPage,
      currentPage,
      totalFiles,
      filesData,
      dataMeta,
      perPageOptions,
      searchQuery,
      fileNo,
      nric,
      lotNo,
      sortBy,
      isSortDirDesc,
      refFilesTable,
      refetchData,

      // Extra Filters
      fileStatusFilter,
      paymentStatusFilter,
      productFilter,
      customerTypeFilter,
      bookingDateFilter,
      confirmDateFilter,
    } = useFileList()

    const selectedFiles = ref([])
    const toggleSelectedFiles = fileId => {
      const fileIndex = selectedFiles.value.indexOf(fileId)

      if (fileIndex === -1) selectedFiles.value.push(fileId)
      else selectedFiles.value.splice(fileIndex, 1)
    }
    const selectAllFilesCheckbox = computed(() => {
      const idsArray1 = filesData.value.map(obj => obj.fileID)
      const count = selectedFiles.value.filter(id => idsArray1.includes(id)).length

      return filesData.value.length && (filesData.value.length === count)
    })
    const isSelectAllFilesCheckboxIndeterminate = computed(() => {
      const idsArray1 = filesData.value.map(obj => obj.fileID)
      const count = selectedFiles.value.filter(id => idsArray1.includes(id)).length

      return Boolean(selectedFiles.value.length) && filesData.value.length !== count
    })
    const selectAllCheckboxUpdate = val => {
      const pageIds = filesData.value.map(flow => flow.fileID)
      if (val) {
        selectedFiles.value = [...new Set([...selectedFiles.value, ...pageIds])]
      } else {
        selectedFiles.value = selectedFiles.value.filter(id => !pageIds.includes(id))
      }
    }

    const computationSelection = computed(() => {
      const idsArray1 = filesData.value.map(obj => obj.fileID)
      const count = selectedFiles.value.filter(id => idsArray1.includes(id)).length
      return count
    })

    const clearSelection = () => {
      selectedFiles.value = []
    }

    return {
      // Sidebar
      fetchFiles,
      tableColumns,
      perPage,
      currentPage,
      totalFiles,
      dataMeta,
      perPageOptions,
      searchQuery,
      fileNo,
      nric,
      lotNo,
      sortBy,
      isSortDirDesc,
      refFilesTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      filesData,

      // Filter
      avatarText,
      canViewThisAction,

      // Extra Filters
      fileStatusFilter,
      paymentStatusFilter,
      productFilter,
      customerTypeFilter,
      bookingDateFilter,
      confirmDateFilter,

      selectAllFilesCheckbox,
      isSelectAllFilesCheckboxIndeterminate,
      selectedFiles,
      toggleSelectedFiles,
      selectAllCheckboxUpdate,
      computationSelection,
      clearSelection,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.dropdown__left-align-adjust{
  ul{
     left: 100% !important;
  }
}
.dropdown__left-align-adjust-mobile{
  ul{
     left: 50% !important;
  }
}
</style>
